module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon3.96428027.png";